/**
 * IntegrationIcons — Real brand SVG icons for each service
 * All icons are inline SVGs for zero external dependencies
 */

interface IconProps {
  size?: number;
  color?: string;
}

export function CloudflareIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M45.937 42.618l2.093-7.226c.392-1.353.215-2.6-.5-3.514-.664-.852-1.748-1.34-3.052-1.377l-22.627-.3c-.15-.002-.283-.072-.367-.192-.088-.125-.107-.285-.052-.432.072-.198.262-.335.478-.346l22.828-.302c2.92-.138 6.095-2.537 7.16-5.418l1.35-3.657c.063-.17.088-.35.074-.528C51.9 12.85 45.88 7.5 38.613 7.5c-6.405 0-11.863 4.088-13.905 9.8-.88-.66-1.972-1.04-3.155-1.04-2.838 0-5.14 2.302-5.14 5.14 0 .453.06.89.168 1.31C11.08 23.073 6.5 27.885 6.5 33.755c0 .558.042 1.106.123 1.644.05.333.338.573.674.573h37.688c.237 0 .45-.148.53-.37l.422-.984z" fill="#F4811F"/>
      <path d="M50.222 20.285c-.196 0-.39.01-.585.025-.125.008-.233.088-.282.208l-.95 2.604c-.392 1.354-.215 2.602.5 3.515.664.852 1.748 1.34 3.052 1.378l4.84.063c.15.002.282.072.366.192.088.125.108.285.053.432-.073.198-.263.335-.478.346l-5.04.067c-2.925.137-6.097 2.536-7.162 5.418l-.39 1.058c-.073.2.075.41.288.41h14.88c.294 0 .556-.192.64-.478.48-1.632.743-3.37.743-5.17 0-5.542-4.493-10.068-10.035-10.068h-.44z" fill="#FAAD3F"/>
    </svg>
  );
}

export function GitHubIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" fill="#fff"/>
    </svg>
  );
}

export function TrelloIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#0079BF"/>
      <rect x="4" y="4" width="7" height="14" rx="1.5" fill="#fff"/>
      <rect x="13" y="4" width="7" height="9" rx="1.5" fill="#fff"/>
    </svg>
  );
}

export function DynadotIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" fill="#2B6CB0"/>
      <path d="M7 8h4c2.2 0 4 1.8 4 4s-1.8 4-4 4H7V8z" fill="#fff" stroke="#fff" stroke-width="1.5"/>
      <circle cx="12" cy="12" r="6" fill="none" stroke="#fff" stroke-width="1" stroke-dasharray="2 2"/>
    </svg>
  );
}

export function NpmIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="#CB3837"/>
      <path d="M4 4h16v16H4z" fill="#CB3837"/>
      <path d="M5.5 5.5h13v13h-6.5v-9.75h-3.25v9.75H5.5z" fill="#fff"/>
    </svg>
  );
}

export function SendGridIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 8h8V0h8v8h8v8h-8v8H8v-8H0V8z" fill="#1A82E2" transform="scale(0.75) translate(4,4)"/>
      <rect x="1" y="1" width="22" height="22" rx="4" fill="#1A82E2" opacity="0.1"/>
      <path d="M4 12l4-4h4v4h4v4h-4v4H8v-4H4v-4z" fill="#1A82E2"/>
    </svg>
  );
}

export function WhatsAppIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="#25D366"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.553 4.122 1.523 5.857L0 24l6.335-1.652A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.82c-1.97 0-3.867-.547-5.508-1.558l-.395-.234-4.1 1.07 1.093-3.987-.258-.41A9.797 9.797 0 012.18 12c0-5.422 4.398-9.82 9.82-9.82 5.422 0 9.82 4.398 9.82 9.82 0 5.422-4.398 9.82-9.82 9.82z" fill="#25D366"/>
    </svg>
  );
}

export function TelegramIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#2AABEE"/>
      <path d="M5.432 11.873l8.772-3.556c.47-.19 2.082-.863 2.082-.863s.742-.288.68.413c-.021.288-.19 1.296-.36 2.39l-.546 3.462s-.045.52-.433.605c-.39.086-.978-.288-.11-.72-.082-.052-1.543-.99-2.09-1.38-.152-.108-.325-.325.01-.578l2.358-2.147s.27-.24.019-.413c0 0-.087-.063-.25.039l-3.122 1.993c-.395.27-.823.03-.823.03l-1.795-.555s-.27-.166.188-.34z" fill="#fff"/>
    </svg>
  );
}

export function HostingerIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#673DE6"/>
      <path d="M7 6v12h3v-5h4v5h3V6h-3v4h-4V6H7z" fill="#fff"/>
    </svg>
  );
}

export function SlackIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.042 15.165a2.528 2.528 0 01-2.52 2.523A2.528 2.528 0 010 15.165a2.527 2.527 0 012.522-2.52h2.52v2.52zm1.27 0a2.527 2.527 0 012.521-2.52 2.527 2.527 0 012.521 2.52v6.313A2.528 2.528 0 018.833 24a2.528 2.528 0 01-2.521-2.522v-6.313z" fill="#E01E5A"/>
      <path d="M8.834 5.042a2.528 2.528 0 01-2.522-2.52A2.528 2.528 0 018.834 0a2.528 2.528 0 012.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 012.521 2.521 2.528 2.528 0 01-2.521 2.521H2.522A2.528 2.528 0 010 8.834a2.528 2.528 0 012.522-2.521h6.312z" fill="#36C5F0"/>
      <path d="M18.956 8.834a2.528 2.528 0 012.522-2.521A2.528 2.528 0 0124 8.834a2.528 2.528 0 01-2.522 2.521h-2.522V8.834zm-1.27 0a2.528 2.528 0 01-2.522 2.521 2.528 2.528 0 01-2.521-2.521V2.522A2.528 2.528 0 0115.165 0a2.528 2.528 0 012.521 2.522v6.312z" fill="#2EB67D"/>
      <path d="M15.165 18.956a2.528 2.528 0 012.521 2.522A2.528 2.528 0 0115.165 24a2.528 2.528 0 01-2.522-2.522v-2.522h2.522zm0-1.27a2.528 2.528 0 01-2.522-2.522 2.528 2.528 0 012.522-2.521h6.313A2.528 2.528 0 0124 15.165a2.528 2.528 0 01-2.522 2.521h-6.313z" fill="#ECB22E"/>
    </svg>
  );
}

export function DiscordIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.317 4.37a19.79 19.79 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" fill="#5865F2"/>
    </svg>
  );
}

export function JiraIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.571 11.513H0a5.218 5.218 0 005.232 5.215h2.13v2.057A5.215 5.215 0 0012.577 24V12.518a1.005 1.005 0 00-1.006-1.005z" fill="#2684FF"/>
      <path d="M11.571 11.513H0a5.218 5.218 0 005.232 5.215h2.13v2.057A5.215 5.215 0 0012.577 24V12.518a1.005 1.005 0 00-1.006-1.005z" fill="url(#jira_a)" opacity="0.5"/>
      <path d="M17.338 5.769H5.767a5.218 5.218 0 005.232 5.214h2.13v2.058A5.215 5.215 0 0018.344 18.256V6.774a1.005 1.005 0 00-1.006-1.005z" fill="#2684FF"/>
      <path d="M23.106 0H11.535a5.218 5.218 0 005.232 5.214h2.13v2.058A5.215 5.215 0 0024.113 12.487V1.005A1.005 1.005 0 0023.106 0z" fill="#2684FF"/>
      <defs><linearGradient id="jira_a" x1="11.99" y1="11.79" x2="7.05" y2="16.85" gradientUnits="userSpaceOnUse"><stop stop-color="#0052CC"/><stop offset="1" stop-color="#2684FF"/></linearGradient></defs>
    </svg>
  );
}

export function GmailIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 010 19.366V5.457c0-.988 1.127-1.551 1.918-.957L12 11.73l10.082-7.23c.791-.594 1.918-.03 1.918.957z" fill="#EA4335"/>
      <path d="M1.636 5.457L12 11.73 22.364 5.457" fill="none" stroke="#fff" stroke-width="0.5"/>
    </svg>
  );
}

export function OutlookIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 7.387v10.478c0 .23-.09.452-.254.616a.868.868 0 01-.616.254h-8.26v-8.06l1.696 1.17a.434.434 0 00.498 0L24 7.387z" fill="#0078D4"/>
      <path d="M16.086 7.093l.826.566 7.088-4.92V5.39L17.566 9.66a1.274 1.274 0 01-1.48 0L9.87 5.39V2.74l6.216 4.353z" fill="#28A8EA"/>
      <path d="M9.87 7.387V19.09h-8.26a.868.868 0 01-.616-.254A.868.868 0 01.74 18.22V5.39l9.13 1.997z" fill="#0078D4" opacity="0.5"/>
      <ellipse cx="6.5" cy="13" rx="3.5" ry="4" fill="#0078D4"/>
      <ellipse cx="6.5" cy="13" rx="2" ry="2.5" fill="#fff"/>
    </svg>
  );
}

export function SemrushIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#FF622D"/>
      <path d="M6 17l3-5 3 3 3-7 3 4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="6" cy="17" r="1.5" fill="#fff"/>
      <circle cx="9" cy="12" r="1.5" fill="#fff"/>
      <circle cx="12" cy="15" r="1.5" fill="#fff"/>
      <circle cx="15" cy="8" r="1.5" fill="#fff"/>
      <circle cx="18" cy="12" r="1.5" fill="#fff"/>
    </svg>
  );
}

export function MajesticIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#E5004B"/>
      <path d="M6 18V10l3 4 3-6 3 6 3-4v8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 4l-1.5 3h3L12 4z" fill="#FFD700"/>
    </svg>
  );
}

export function SimilarWebIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" fill="#1B2845"/>
      <circle cx="12" cy="12" r="7" fill="none" stroke="#4FC3F7" stroke-width="1.5"/>
      <circle cx="12" cy="12" r="3.5" fill="none" stroke="#4FC3F7" stroke-width="1.5"/>
      <circle cx="12" cy="12" r="1" fill="#4FC3F7"/>
      <line x1="12" y1="1" x2="12" y2="5" stroke="#4FC3F7" stroke-width="1"/>
      <line x1="12" y1="19" x2="12" y2="23" stroke="#4FC3F7" stroke-width="1"/>
      <line x1="1" y1="12" x2="5" y2="12" stroke="#4FC3F7" stroke-width="1"/>
      <line x1="19" y1="12" x2="23" y2="12" stroke="#4FC3F7" stroke-width="1"/>
    </svg>
  );
}

export function UptimeRobotIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="5" fill="#3BD671"/>
      <circle cx="12" cy="10" r="4" fill="#fff"/>
      <circle cx="12" cy="10" r="2" fill="#3BD671"/>
      <path d="M8 15c0-2.21 1.79-3 4-3s4 .79 4 3v2H8v-2z" fill="#fff"/>
      <rect x="10" y="5" width="4" height="2" rx="1" fill="#fff"/>
    </svg>
  );
}

export function SignalIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1z" fill="#3A76F0"/>
      <path d="M17.5 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="#fff"/>
    </svg>
  );
}

export function GoogleChatIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h3v4l4-4h9c1.1 0 2-.9 2-2V6z" fill="#00AC47"/>
      <circle cx="8" cy="11" r="1.5" fill="#fff"/>
      <circle cx="12" cy="11" r="1.5" fill="#fff"/>
      <circle cx="16" cy="11" r="1.5" fill="#fff"/>
    </svg>
  );
}

export function WebChatIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="20" height="14" rx="3" fill="#6366F1"/>
      <path d="M7 20l3-2h8c1.1 0 2-.9 2-2" stroke="#6366F1" stroke-width="2" fill="none"/>
      <circle cx="8" cy="11" r="1" fill="#fff"/>
      <circle cx="12" cy="11" r="1" fill="#fff"/>
      <circle cx="16" cy="11" r="1" fill="#fff"/>
    </svg>
  );
}

export function NostrIcon({ size = 24 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" fill="#8B5CF6"/>
      <path d="M12 5c-2.5 0-4.5 1.5-4.5 4 0 1.5.8 2.8 2 3.5L8 19h8l-1.5-6.5c1.2-.7 2-2 2-3.5 0-2.5-2-4-4.5-4z" fill="#fff"/>
      <circle cx="10.5" cy="9" r="1" fill="#8B5CF6"/>
      <circle cx="13.5" cy="9" r="1" fill="#8B5CF6"/>
    </svg>
  );
}

// Map integration ID to icon component
export const INTEGRATION_ICONS: Record<string, (props: IconProps) => any> = {
  cloudflare: CloudflareIcon,
  github: GitHubIcon,
  trello: TrelloIcon,
  dynadot: DynadotIcon,
  npm: NpmIcon,
  sendgrid: SendGridIcon,
  whatsapp: WhatsAppIcon,
  telegram: TelegramIcon,
  hostinger: HostingerIcon,
  slack: SlackIcon,
  discord: DiscordIcon,
  jira: JiraIcon,
  gmail: GmailIcon,
  outlook: OutlookIcon,
  semrush: SemrushIcon,
  majestic: MajesticIcon,
  similarweb: SimilarWebIcon,
  uptimerobot: UptimeRobotIcon,
  signal: SignalIcon,
  googlechat: GoogleChatIcon,
  webchat: WebChatIcon,
  nostr: NostrIcon,
  email: GmailIcon,
};
